
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowPointer } from '../../assets/icons';
import ProcessSuccessful from '../../assets/icons/ProcessSuccessful';
import { getBudgetHistory } from '../../backend-services';
import PageLoader from '../../components/common/PageLoader';
import ExpenseInfoWidget from '../../components/expense/ExpenseInfoWidget';


  const ExpenseNotificationPage = () => {
  const navigate = useNavigate();
  const {  updatedId} = useParams();
  console.log("createdExpenseId:",  updatedId);
  const handleViewExpense = () => {

    const viewInvoiceRoute = `/expenses/${ updatedId}/view`;
    navigate(viewInvoiceRoute);
  };
  const handlePrinting = () => {
    // Add the printing logic here
    console.log('Printing...');
  };
  const [isDataLoading, setIsDataLoading] = useState(true);
  const getBudget = React.useCallback(async () => {
    const date = new Date().toISOString();
      const startMonthYear = date.split('T')[0].slice(0, 7).split('-').reverse().join('-');
      const endMonthYear = date.split('T')[0].slice(0, 7).split('-').reverse().join('-');
    return await getBudgetHistory(startMonthYear, endMonthYear);
  }, []);

  useEffect(() => {
    // Fetch data and set loading state to false
    getBudget().then(() => {
      setIsDataLoading(false);
    });
  }, []);

  return (
    <>
   
      <div className="h-screen">
    <div className="  flex justify-center mt-[3em] text-[16px] ">
          <h3 className='mt-[-2em] font-bold'>Your Expense has been saved</h3>
        </div>
        <div className="flex justify-center mt-[1em] "> <ProcessSuccessful/></div>
        <div role="form" onSubmit={(e) => e.preventDefault()}>
        <div className='mt-[2em]'>
  
        {isDataLoading ? <PageLoader /> : <ExpenseInfoWidget getBudget={getBudget} Icon={ArrowPointer} />}
   
      </div>
          <div className="flex justify-center  pt-[79px] pb-[40px] ">
            <button
              className="w-[215px] h-[48px] rounded-md text-[#FFFFFF] text-[16px] font-medium bg-[#FF6702]"
               onClick={handleViewExpense}
            >
             Continue
            </button>
          </div>
          <div className="flex justify-center pb-[40px]  ">
            <button
              className="w-[215px] h-[48px] rounded-md text-[#044E97] border border-[#044E97] text-[16px] font-medium bg-[#FFFFFF]"
              onClick={handlePrinting}
            >
           Convert to Invoice
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export { ExpenseNotificationPage};
